import React, { useState } from 'react';

const PhotoViewer = ({ assetId, photos = [], onManagePhotos }) => {
    const [showGallery, setShowGallery] = useState(false);
    
    // Parse photos if it's a JSON string
    const parsedPhotos = typeof photos === 'string' ? 
        (photos ? JSON.parse(photos) : []) : 
        (Array.isArray(photos) ? photos : []);

    const photoCount = parsedPhotos.length;

    if (photoCount === 0) {
        return (
            <button 
                onClick={() => onManagePhotos && onManagePhotos(assetId)}
                style={{
                    backgroundColor: '#f8f9fa',
                    border: '1px dashed #6c757d',
                    color: '#6c757d',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '12px'
                }}
            >
                Add Photos
            </button>
        );
    }

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <button
                    onClick={() => setShowGallery(true)}
                    style={{
                        backgroundColor: '#007bff',
                        color: 'white',
                        border: 'none',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '12px'
                    }}
                >
                    View ({photoCount})
                </button>
                {onManagePhotos && (
                    <button
                        onClick={() => onManagePhotos(assetId)}
                        style={{
                            backgroundColor: 'transparent',
                            color: '#007bff',
                            border: 'none',
                            padding: '4px 8px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            textDecoration: 'underline'
                        }}
                    >
                        Manage
                    </button>
                )}
            </div>

            {showGallery && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        padding: '24px',
                        maxWidth: '800px',
                        width: '90%',
                        maxHeight: '90%',
                        overflow: 'auto',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
                    }}>
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center',
                            marginBottom: '20px',
                            borderBottom: '1px solid #eee',
                            paddingBottom: '12px'
                        }}>
                            <h3 style={{ margin: 0, color: '#333' }}>
                                Asset Photos ({photoCount})
                            </h3>
                            <button 
                                onClick={() => setShowGallery(false)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '24px',
                                    cursor: 'pointer',
                                    color: '#999',
                                    padding: '0',
                                    width: '30px',
                                    height: '30px'
                                }}
                            >
                                ×
                            </button>
                        </div>

                        {photoCount > 0 ? (
                            <div style={{ 
                                display: 'grid', 
                                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', 
                                gap: '16px',
                                padding: '16px 0'
                            }}>
                                {parsedPhotos.map((photo, index) => (
                                    <div key={index} style={{ textAlign: 'center' }}>
                                        <img
                                            src={`http://localhost/asset/${photo}`}
                                            alt={`Asset photo ${index + 1}`}
                                            style={{ 
                                                width: '200px',
                                                height: '150px',
                                                objectFit: 'cover',
                                                border: '1px solid #ddd',
                                                borderRadius: '6px',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => {
                                                // Open full size image in new tab
                                                window.open(`http://localhost/asset/${photo}`, '_blank');
                                            }}
                                            onError={(e) => {
                                                e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjE1MCIgdmlld0JveD0iMCAwIDIwMCAxNTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMTUwIiBmaWxsPSIjRjVGNUY1Ii8+CjxwYXRoIGQ9Ik04NS41IDc1TDk1IDY1TDEwNS41IDc1TDExNSA2NUwxMjUgNzVWODVIODVWNzVaIiBmaWxsPSIjQ0NDIi8+CjxjaXJjbGUgY3g9IjEwNSIgY3k9IjQ1IiByPSI1IiBmaWxsPSIjQ0NDIi8+Cjx0ZXh0IHg9IjEwMCIgeT0iMTEwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjOTk5IiBmb250LXNpemU9IjEyIj5JbWFnZSBub3QgZm91bmQ8L3RleHQ+Cjwvc3ZnPg==';
                                                e.target.style.backgroundColor = '#f5f5f5';
                                            }}
                                        />
                                        <div style={{ 
                                            marginTop: '8px', 
                                            fontSize: '12px', 
                                            color: '#666',
                                            wordBreak: 'break-all'
                                        }}>
                                            Photo {index + 1}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div style={{ 
                                textAlign: 'center', 
                                padding: '40px 20px',
                                color: '#999'
                            }}>
                                <div style={{ fontSize: '48px', marginBottom: '16px' }}>Camera</div>
                                <div>No photos available</div>
                            </div>
                        )}

                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'center', 
                            borderTop: '1px solid #eee',
                            paddingTop: '16px',
                            marginTop: '20px'
                        }}>
                            <button
                                onClick={() => setShowGallery(false)}
                                style={{
                                    backgroundColor: '#6c757d',
                                    color: 'white',
                                    border: 'none',
                                    padding: '8px 16px',
                                    borderRadius: '4px',
                                    cursor: 'pointer'
                                }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PhotoViewer;